import { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import api from "@/lib/api";
import { useLocation } from "react-router-dom";

/** iter447 pt 2 — « Masquer les chiffres » (tableaux de bord). Préférence serveur `hide_dashboard_amounts` ; quand actif sur un tableau de bord,
 *  fmtDA / fmtMoney rendent « ••••••• DA » (pourcentages et compteurs intacts). */
const S = { pref: null, onDash: false, subs: new Set() };
const emit = () => S.subs.forEach((f) => f());
export const amountsMasked = () => !!S.pref && S.onDash;
export const MASKED = "••••••• DA";
export const maskStyle = { letterSpacing: 2, color: "#6B6B73" };
export const DASH_PATHS = ["/tresorerie", "/crm/dashboard", "/dashboard", "/crm/stats", "/"];
const isDash = (p) => p === "/" || p === "/dashboard" || p === "/tresorerie" || p === "/crm/dashboard" || p.startsWith("/crm/stats");

export function useAmountsMask() {
  const [, tick] = useState(0);
  const loc = useLocation();
  useEffect(() => { S.onDash = isDash(loc.pathname); emit(); return () => { S.onDash = false; emit(); }; }, [loc.pathname]);
  useEffect(() => {
    const f = () => tick((n) => n + 1); S.subs.add(f);
    if (S.pref === null) api.get("/me/prefs").then(({ data }) => { S.pref = !!data.hide_dashboard_amounts; emit(); }).catch(() => {});
    return () => S.subs.delete(f);
  }, []);
  return [amountsMasked(), async () => { S.pref = !S.pref; emit(); try { await api.patch("/me/prefs", { hide_dashboard_amounts: S.pref }); } catch { /* ignore */ } }];
}

export function HideAmountsButton() {
  const [on, toggle] = useAmountsMask();
  return (
    <button type="button" onClick={toggle} className="inline-flex items-center" aria-pressed={on} data-testid="hide-amounts-toggle"
      style={{ gap: 6, height: 28, padding: "0 10px", borderRadius: 8, fontSize: 11, color: on ? "#C4B5FD" : "#E8E8EA", background: on ? "#1E1C2E" : "transparent", border: `1px solid ${on ? "#7C5CE0" : "#33333B"}` }}>
      {on ? <EyeOff size={14} color="#C4B5FD" /> : <Eye size={14} color="#93B4F5" />}{on ? "Afficher les chiffres" : "Masquer les chiffres"}
    </button>
  );
}

/** À appeler dans chaque page de tableau de bord : re-rend la page quand le masque change (fmtDA / fmtMoney relus). */
export function useAmountsMaskVersion() {
  const [, tick] = useState(0);
  useEffect(() => { const f = () => tick((n) => n + 1); S.subs.add(f); return () => S.subs.delete(f); }, []);
}
